/**
 * Thrown by ServiceAuthAdapter.refreshToken() on any failure:
 *   - no session in sessionStorage
 *   - backend returned non-2xx (status is the HTTP status code)
 */
export class AuthRefreshError extends Error {
  constructor(
    public readonly reason: string,
    public readonly status?: number,
  ) {
    super(`Auth refresh failed: ${reason}${status ? ` (${status})` : ''}`);
    this.name = 'AuthRefreshError';
  }
}
